import script from "./SignPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SignPage.vue?vue&type=script&setup=true&lang=js"

import "./SignPage.vue?vue&type=style&index=0&id=360cf7f1&lang=css"

const __exports__ = script;

export default __exports__